import { axiosInstance } from '.'
import { GET_COMING_SOON_OPPORTUNITIES } from './endpoints'

export type ComingSoonPublicItem = {
  id: number
  coverImageUrl: string
  title: string
  description: string
}

export const comingSoonServices = {
  getPublicList: async () => {
    const { data } = await axiosInstance.get<{ items: ComingSoonPublicItem[] }>(
      GET_COMING_SOON_OPPORTUNITIES,
    )
    return data
  },
}
